import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import configureStore from "./store/configureStore";
import { initIssues } from "./actions/IssueActions";
import initialState from "./reducers/initialState";
import userState from "./reducers/userState";

const store = configureStore({"issues": initialState, "users": userState});
store.dispatch(initIssues(""));
//store.dispatch()

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
